import { DeformableTransform } from '~/domain/dvf/deformableTransform';
import { Grid } from '~/engine/data/common/Grid';
import {
    deformableVolumeMapping,
    ResampleVolumeOptions,
    resampleVolumeInto,
} from './resampleVolume';

export type WarpImageVolumeOptions = ResampleVolumeOptions;

export interface WarpedVolume {
    readonly pixels: Int16Array;
    readonly voxelsOutsideField: number;
}

export async function warpImageVolume(
    srcPixels: Int16Array,
    srcGrid: Grid,
    dstGrid: Grid,
    transform: DeformableTransform,
    options: WarpImageVolumeOptions = {}
): Promise<WarpedVolume | null> {
    if (srcPixels.length !== srcGrid.sizeX * srcGrid.sizeY * srcGrid.sizeZ) {
        throw new Error('Source pixel data length does not match srcGrid.');
    }
    const mapping = deformableVolumeMapping(transform);
    const pixels = new Int16Array(
        (dstGrid.sizeX | 0) * (dstGrid.sizeY | 0) * (dstGrid.sizeZ | 0)
    );
    const coverage = await resampleVolumeInto(
        srcPixels,
        srcGrid,
        pixels,
        dstGrid,
        mapping,
        options
    );
    return coverage
        ? { pixels, voxelsOutsideField: coverage.unmappedVoxels }
        : null;
}
